/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SecurityProfileLevel {
    None = 0,
    StandardUser = 100,
    ReportSuperUser = 150,
    ExternalTrainer = 175,
    Supervisor = 180,
    EventManager = 220,
    CourseManager = 240,
    UserManager = 260,
    EventAdministrator = 320,
    CourseAdministrator = 340,
    UserAdministrator = 360,
    CompanyAdministrator = 450,
    IntellekAdministrator = 500,
}
